import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/logs';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageLogs() {
  return (
    <Root title={PAGE_TITLE.LOGS}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
